module.exports = __webpack_public_path__ + "08a6238d.png";